var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "layout-builder-layout-placeholder-contact-info" },
      [
        _c(
          "div",
          { staticClass: "layout-builder-layout-placeholder-contact-info-top" },
          [
            _c("div", {
              staticClass:
                "layout-builder-layout-placeholder-contact-info-top-avatar",
            }),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "layout-builder-layout-placeholder-contact-info-top-line-top",
            }),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "layout-builder-layout-placeholder-contact-info-top-line-bottom",
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "layout-builder-layout-placeholder-contact-info-center",
          },
          [
            _c("div", {
              staticClass:
                "layout-builder-layout-placeholder-contact-info-center-line-top",
            }),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "layout-builder-layout-placeholder-contact-info-center-line-bottom",
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "layout-builder-layout-placeholder-contact-info-bottom",
          },
          [
            _c("div", {
              staticClass:
                "layout-builder-layout-placeholder-contact-info-bottom-line-top",
            }),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "layout-builder-layout-placeholder-contact-info-bottom-line-center",
            }),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "layout-builder-layout-placeholder-contact-info-bottom-line-bottom",
            }),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }